// components/Loader.js
import React from 'react';
import loaderAnim from '../assets/images/Loader anim.png';

const Loader = ({ text, size, color }) => {
    return (
        <div className={`text-center spinner-${size}  text-${color}`}>
             <img src={loaderAnim} alt="Loading" className="loader-anim-image rotate-animation"
              style={{ width: size ? `${size}px` : '30px', height: 'auto' }} />
             <span className="spin-text mx-2">{text}...</span>
        </div>
    );
};



export default Loader;
